<template>
  <div>
    <b-container class="p-3" fluid>
      <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
        <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
        Back
      </b-button>
      <b-row>
        <b-col class="">
          <h4 class="">Your Groups</h4>
          <b-row>
            <b-col>
              <b-skeleton-wrapper class="text-center" :loading="loading2">
                <template #loading>
                  <b-skeleton height="100px" width="100%"></b-skeleton>
                </template>
              </b-skeleton-wrapper>
              <div v-if="!loading2" class="board-wrapper">
                <digit-board
                  class="board-items"
                  title="Total Number of Groups"
                  symbol=""
                  :value="analyticsData?.totalGroups"
                  color="green"
                ></digit-board>
                <digit-board
                  class="board-items"
                  title="Number of Active Groups"
                  symbol=""
                  :value="analyticsData?.totalActiveGroups"
                  color="green"
                ></digit-board>
                <digit-board
                  class="board-items"
                  title="Number of Inactive Groups"
                  symbol=""
                  :value="analyticsData?.totalInactiveGroups"
                  color="green"
                ></digit-board>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col class="m-0 p-3">
          <div class="nested-form-group">
            <div class="flex-head mb-3">
              <b-button
                class="prompt-button p-2"
                :to="{ name: 'addnewgrouporg' }"
                variant="success"
                >Create New Group</b-button
              >
            </div>
            <div style="width: 400px">
              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="search"
                  v-model="searchQuery"
                  @keyup="searchFilter"
                  @update="clearFilter"
                  @focus="searching = true"
                  placeholder="Search"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>

          <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>

          <b-table
            v-if="tableData?.length > 0 && !loading"
            striped
            hover
            responsive
            head-variant="dark"
            class="tablerr"
            :items="tableData"
            :fields="headers"
          >
            <template #cell(sn)="data">
              {{ data.index + 1 + (pages - 1) * intervalnum }}
            </template>
            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(description)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(created_at)="data">
              <span>{{ dateFormatter(data.value) }}</span>
            </template>
            <template #cell(tags)="data">
              <span>{{ data.value.join(", ") }}</span>
            </template>
            <template #cell(status)="data">
              <span>
                <b-badge
                  :variant="data.value == 'inactive' ? 'danger' : 'success'"
                  >{{ capitalizeString(data.value) }}</b-badge
                >
              </span>
            </template>
            <template #cell(action)="data">
              <div style="cursor: pointer">
                <b-icon-three-dots-vertical
                  :id="`popover-1-table-ts${data.index}`"
                  variant="primary"
                ></b-icon-three-dots-vertical>
                <b-popover
                  :target="`popover-1-table-ts${data.index}`"
                  placement="bottomright"
                  title=""
                  triggers="hover focus"
                >
                  <div style="width: 170px; min-height: 40px" class="">
                    <div
                      @click="
                        $router.push({
                          name:
                            details.category == 'Organization'
                              ? 'viewgrouporg'
                              : 'viewgrouporg',
                          params: { trackid: data.item.track_id }
                        })
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">View</p>
                    </div>
                    <div
                      @click="
                        $router.push({
                          name:
                            details.category == 'Organization'
                              ? 'editgrouporg'
                              : 'editgrouporg',
                          params: { trackid: data.item.track_id }
                        })
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Edit</p>
                    </div>
                    <div
                      @click="
                        data.item.status == 'active'
                          ? $bvModal.show('deactivate')
                          : $bvModal.show('reactivate'),
                          (currentGroupId = data.item.track_id)
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">
                        {{
                          data.item.status == "active"
                            ? "Deactivate"
                            : "Activate"
                        }}
                      </p>
                    </div>
                    <!-- <div
                        @click="
                            $router.push({ name: 'addnewcandidateorg', query: { group_id : data.item.track_id } })
                        "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Add a Candidate</p>
                    </div>
                    <div
                        @click="
                            $router.push({ name: 'importnewcandidatesorg', query: { group_id : data.item.track_id } })
                        "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Import Candidates</p>
                    </div> -->
                    <div
                      @click="
                        $bvModal.show('modal-truncate'),
                          (currentGroupId = data.item.track_id)
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Truncate</p>
                    </div>
                    <div
                      @click="
                        $bvModal.show('modal-delete'),
                          (currentGroupId = data.item.track_id)
                      "
                      class="cursor-pointer action-link p-1 px-2"
                    >
                      <p class="text-sm">Delete</p>
                    </div>
                  </div>
                </b-popover>
              </div>
            </template>
          </b-table>

          <div class="text-center mt-5" v-if="tableData?.length <= 0">
            No Data to show
          </div>

          <paginater
            :intervalnum="intervalnum"
            :pages="pages"
            :endnum="endnum"
            :endss="endss"
            :datalength="endss"
            @paginator="newPage"
            @changeInterval="effectInterval"
          ></paginater>

          <b-modal
            id="modal-delete"
            centered
            title="Confirm Delete"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="performDelete"
          >
            <template v-slot:modal-ok> Delete </template>
            <p>
              This Group and all its Candidates will be permanently deleted. Are
              you sure you want to proceed? Your actions cannot be undone
            </p>
          </b-modal>

          <b-modal
            id="modal-truncate"
            centered
            title="Confirm Truncate Action"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="performTruncate"
          >
            <template v-slot:modal-ok> Truncate </template>
            <p>
              All the Candidates of this group will be deleted. Are you sure you
              want to proceed? Your actions cannot be undone
            </p>
          </b-modal>

          <b-modal
            id="modal-deactivate"
            centered
            title="Confirm Deactivate Action"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="performDeactivate"
          >
            <template v-slot:modal-ok> Deactivate </template>
            <p>
              This Group will be deactivated. You can reactivate anytime
            </p>
          </b-modal>

          <b-modal
            id="modal-reactivate"
            centered
            title="Confirm Reactivate Action"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="performActivate"
          >
            <template v-slot:modal-ok> Reactivate </template>
            <p>
              Reactivate this Group
            </p>
          </b-modal>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Paginater from "@/components/Paginater";
import digitBoard from "@/components/digitBoard";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    Paginater,
    digitBoard
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      searchQuery: "",
      searching: false,
      loading: false,
      meta: {},
      tableData: [],
      analyticsData: {},
      loading2: false,
      currentGroupId: ""
    };
  },
  mounted() {
    let curpage = 1;
    this.endnum = this.endnum * Number(curpage);
    this.pager = curpage;

    this.setCurrentModule("Candidates & Groups");
    this.fetchData();
    this.fetchAnalyticsData();
  },
  methods: {
    ...mapActions("admin", [
      "setQuery",
      "fetchGroupsTable",
      "fetchGroupsAnalytics",
      "deleteGroup",
      "truncateGroup",
      "setCurrentModule"
    ]),
    async fetchData() {
      this.loading = true;
      try {
        const response = await this.fetchGroupsTable();
        this.tableData = response?.data;
        this.meta = response?.meta;
        this.endnum = this.meta?.perPage * Number(this.meta?.page);
        this.loading = false;

        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    async fetchAnalyticsData() {
      this.loading2 = true;
      try {
        const response = await this.fetchGroupsAnalytics();
        this.analyticsData = response?.data;
        this.loading2 = false;

        console.log(response);
      } catch (err) {
        console.log(err);
        this.loading2 = false;
      }
    },
    async performDelete() {
      this.loading = true;
      try {
        const response = await this.deleteGroup(this.currentGroupId);
        this.loading = false;

        await this.$bvToast.toast(`${response.message}`, {
          title: `Successful`,
          variant: "success",
          solid: true
        });

        this.fetchData();
        this.fetchAnalyticsData();
      } catch (err) {
        console.log(err);
      }
    },
    async performTruncate() {
      this.loading = true;
      try {
        const response = await this.truncateGroup(this.currentGroupId);
        this.loading = false;

        await this.$bvToast.toast(`${response.message}`, {
          title: `Successful`,
          variant: "success",
          solid: true
        });

        this.fetchData();
        this.fetchAnalyticsData();

        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      //   let newend = this.intervalnum * page;

      let search =
        this.searchQuery.length > 0 ? `&search=${this.searchQuery}` : "";
      this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}${search}`);
      this.fetchData();
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    clearField() {
      this.searchQuery = "";
      this.closeSearch();
    },

    async clearFilter(event) {
      if (event?.length == 0) {
        this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
        this.fetchData();
      }
    },

    async searchFilter() {
      this.searching = true;
      //   let query = this.searchQuery;

      try {
        if (this.searchQuery.length == 0) {
          this.clearField();
          this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
          this.fetchData();
          this.searching = false;
        } else {
          this.setQuery(
            `page=${this.pages}&perPage=${this.intervalnum}&search=${this.searchQuery}`
          );
          this.fetchData();
          this.searching = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeSearch() {
      this.searching = false;
      this.searchQuery = "";
    }
  },

  computed: {
    ...mapState({
      details: state => state.loginmaster.details
    }),

    headers() {
      return [
        "sn",
        "name",
        "description",
        "no_of_candidates",
        "tags",
        "created_at",
        "status",
        "action"
      ];
    },

    usetableData() {
      return this?.tableData;
    },
    endss() {
      let end = this.meta?.total;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.tableData?.length / this.intervalnum);
      return ranger;
    },
    retrieving() {
      //let trid = this.$route.params.trackid;

      let curres = this.tableData?.length;
      //this.result = curres;

      if (curres <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.nested-form-group {
  display: flex;
  flex-wrap: no-wrap;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.allrewr {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.maxres {
  border-radius: 5px 5px;
}

.maxres:hover {
  background-color: #eeeeee;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.spinver {
  width: 7rem;
  height: 7rem;
}
.head-p {
  width: 15%;
  padding: 2px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}
.flex-head {
  display: flex;
  justify-content: flex-end;
}

.board-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
}
.board-items {
  width: 30%;
  margin: 3px;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }

  .board-items {
    width: 100%;
    margin: 3px;
  }
}
</style>
